/**
 * Tour 2: AI Chat Modes — "Let AI design your network"
 */

const TOUR_ID = "ai-chat-modes";

/** @param {{ t: (key: string, opts?: object) => string }} deps */
export function getAiChatModesSteps({ t }) {
  return {
    id: TOUR_ID,
    label: t("AI Chat Modes", { defaultValue: "AI Chat Modes" }),
    description: t("Let AI design your network", {
      defaultValue: "Let AI design your network",
    }),
    steps: [
      {
        element: '[data-tour="ai-chat"]',
        popover: {
          title: t("AI Topology Assistant", {
            defaultValue: "AI Topology Assistant",
          }),
          description: t(
            "Meet your AI topology assistant. It understands IT and OT networks and can design, modify, and explain topologies.",
            {
              defaultValue:
                "Meet your AI topology assistant. It understands IT and OT networks and can design, modify, and explain topologies.",
            },
          ),
          side: "right",
          align: "start",
        },
      },
      {
        element: '[data-tour="chat-mode-selector"]',
        popover: {
          title: t("Interaction Modes", {
            defaultValue: "Interaction Modes",
          }),
          description: t(
            "Choose how the AI helps you. Each mode serves a different purpose — from asking questions to building full topologies.",
            {
              defaultValue:
                "Choose how the AI helps you. Each mode serves a different purpose — from asking questions to building full topologies.",
            },
          ),
          side: "right",
          align: "start",
        },
      },
      {
        element: '[data-tour="chat-mode-ask"]',
        popover: {
          title: t("Ask Mode", { defaultValue: "Ask Mode" }),
          description: t(
            "Get answers about networking concepts without changing the canvas. Great for learning and quick lookups.",
            {
              defaultValue:
                "Get answers about networking concepts without changing the canvas. Great for learning and quick lookups.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-mode-agent"]',
        popover: {
          title: t("Agent Mode", { defaultValue: "Agent Mode" }),
          description: t(
            "Tell the AI what to build or change. It edits the canvas directly — adding devices, connections, and metadata.",
            {
              defaultValue:
                "Tell the AI what to build or change. It edits the canvas directly — adding devices, connections, and metadata.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-mode-plan"]',
        popover: {
          title: t("Plan Mode", { defaultValue: "Plan Mode" }),
          description: t(
            "For complex designs. The AI drafts a detailed plan first, then you approve, request revisions, or cancel before it builds.",
            {
              defaultValue:
                "For complex designs. The AI drafts a detailed plan first, then you approve, request revisions, or cancel before it builds.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="action-import"]',
        popover: {
          title: t("Import Topology", { defaultValue: "Import Topology" }),
          description: t(
            "Import a topology from JSON data or upload a screenshot/photo of a network diagram. The AI extracts devices and connections into an editable topology.",
            {
              defaultValue:
                "Import a topology from JSON data or upload a screenshot/photo of a network diagram. The AI extracts devices and connections into an editable topology.",
            },
          ),
          side: "bottom",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-input"]',
        popover: {
          title: t("Chat Input", { defaultValue: "Chat Input" }),
          description: t(
            'Type your request here. Try: "Build a 3-tier web application network with load balancer and firewall"',
            {
              defaultValue:
                'Type your request here. Try: "Build a 3-tier web application network with load balancer and firewall"',
            },
          ),
          side: "top",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-history-btn"]',
        popover: {
          title: t("Chat History", { defaultValue: "Chat History" }),
          description: t(
            "Open your conversation history. Each thread is a separate project you can switch between.",
            {
              defaultValue:
                "Open your conversation history. Each thread is a separate project you can switch between.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-new-thread"]',
        popover: {
          title: t("New Chat", { defaultValue: "New Chat" }),
          description: t(
            "Start a fresh conversation. Each chat thread maintains its own context and topology state.",
            {
              defaultValue:
                "Start a fresh conversation. Each chat thread maintains its own context and topology state.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
    ],
  };
}

export default getAiChatModesSteps;
